/** Lista padrão — solicitação de exames oftalmológicos (grade OD/OE/AO). */

export interface OphthalmologyExamRowDef {
  key: string;
  label: string;
}

export const OPHTHALMOLOGY_STANDARD_EXAMS: OphthalmologyExamRowDef[] = [
  { key: 'oct_macula', label: 'OCT Mácula' },
  { key: 'oct_nerve', label: 'OCT do Nervo' },
  { key: 'oct_nerve_macula', label: 'OCT Nervo e Mácula' },
  { key: 'ultrassonografia', label: 'Ultrassonografia' },
  { key: 'retinografia', label: 'Retinografia' },
  { key: 'biometria_optica', label: 'Biometria Óptica' },
  { key: 'biometria_us', label: 'Biometria US' },
  { key: 'paquimetria', label: 'Paquimetria' },
  { key: 'gonioscopia', label: 'Gonioscopia' },
  { key: 'topografia_cornea', label: 'Topografia de Córnea' },
  { key: 'pentacam', label: 'Pentacam' },
  { key: 'microscopia_especular', label: 'Microscopia Especular' },
  { key: 'mapeamento_retina', label: 'Mapeamento de Retina' },
  { key: 'curva_tensional', label: 'Curva Tensional (Minicurva)' },
  { key: 'campo_visual_humphrey', label: 'Campo Visual Humphrey 10:2 e 24:2' },
];

export type OphthalmologyExamSelection = Record<
  string,
  { od: boolean; oe: boolean; ao: boolean }
>;

export function emptyOphthalmologySelections(): OphthalmologyExamSelection {
  return Object.fromEntries(
    OPHTHALMOLOGY_STANDARD_EXAMS.map((e) => [e.key, { od: false, oe: false, ao: false }]),
  );
}

/** Texto para anexar à evolução / impressão. */
export function buildOphthalmologyExamOrderBody(
  selections: OphthalmologyExamSelection,
  outrosText: string,
  observacoes: string,
): string {
  const lines: string[] = [
    'SOLICITAÇÃO DE EXAMES — OFTALMOLOGIA',
    '',
    'Exame'.padEnd(44) + 'OD'.padStart(4) + '  ' + 'OE'.padStart(4) + '  ' + 'AO'.padStart(4),
    '─'.repeat(58),
  ];

  for (const row of OPHTHALMOLOGY_STANDARD_EXAMS) {
    const s = selections[row.key];
    if (!s || (!s.od && !s.oe && !s.ao)) continue;
    const od = s.od ? '✓' : ' ';
    const oe = s.oe ? '✓' : ' ';
    const ao = s.ao ? '✓' : ' ';
    const label = row.label.length > 42 ? `${row.label.slice(0, 39)}…` : row.label;
    lines.push(label.padEnd(44) + od.padStart(4) + '  ' + oe.padStart(4) + '  ' + ao.padStart(4));
  }

  lines.push('');
  if (outrosText.trim()) {
    lines.push('Outros — especificar:', outrosText.trim(), '');
  }
  if (observacoes.trim()) {
    lines.push('Observações:', observacoes.trim(), '');
  }

  lines.push('Legenda: OD = olho direito · OE = olho esquerdo · AO = ambos os olhos');

  return lines.join('\n').trim();
}
